export default "__VITE_ASSET__B3Rxw$Hg__"